import {
  FocusOnce,
  ModalBody,
  ModalButton,
  ModalFooter,
  ModalHeader,
} from "baseui/modal";
import CircleLoader from "components/atoms/CircleLoader";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { modalActions } from "redux/slices/modal/modalReducer";
import Button from "components/atoms/Button";
import ContactService from "services/contact.service";

export default function ContactStatus() {
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.contacts);
  const { id, status } = useAppSelector((state) => state.modal.data);

  const handleClick = async () => {
    let payload = {
      id: id,
      status: status,
    };
    ContactService.contactStatus(payload, dispatch);
  };
  return (
    <div>
      <FocusOnce>
        <ModalHeader>Contact Status</ModalHeader>
      </FocusOnce>
      <ModalBody>
        {loading && <CircleLoader />}
        Are you sure you want make this query status as {status}?
      </ModalBody>

      <ModalFooter>
        <ModalButton
          size="compact"
          kind="tertiary"
          onClick={() => dispatch(modalActions.closeModal())}
        >
          No
        </ModalButton>
        <Button size="compact" onClick={handleClick}>
          Yes
        </Button>
      </ModalFooter>
    </div>
  );
}
